export default [
  {
    path: '/stale-outsourcing-status',
    name: 'stale-outsourcing-status',
    props: true,
    component: () => import('@/views/synchronization/StaleStatus.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Statuts non mis à jour',
      pageDesc: 'Consultez les colis synchronisés sans activité récente de statut.',
      accessibility: {
        ariaLabel: 'Liste des statuts non mis à jour',
        breadcrumbLabel: 'Fil d’Ariane des statuts non mis à jour',
      },
      breadcrumb: [
        {
          text: 'Statuts non mis à jour',
          to: { name: 'stale-outsourcing-status' },
          ariaLabel: 'Accueil statuts non mis à jour',
        },
        {
          text: 'Liste',
          active: true,
          ariaLabel: 'Liste des statuts non mis à jour',
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/synchronization/state',
    name: 'sync-state-orders',
    props: true,
    component: () => import('@/views/synchronization/SyncStateOrders.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'État de synchronisation',
      pageDesc: 'Consultez les colis assignés à une société externe mais sans code externe.',
      accessibility: {
        ariaLabel: 'Liste des échecs de synchronisation',
        breadcrumbLabel: 'Fil d’Ariane des échecs de synchronisation',
      },
      breadcrumb: [
        {
          text: 'État de synchronisation',
          to: { name: 'sync-state-orders' },
          ariaLabel: 'Accueil état de synchronisation',
        },
        {
          text: 'Liste',
          active: true,
          ariaLabel: 'Liste des échecs de synchronisation',
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/synchronization',
    name: 'synchronization-list',
    props: true,
    component: () => import('@/views/synchronization/Index.vue'),
    meta: {
      requireLogin: true,
      pageDesc: 'Consultez et gérez les synchronisations de données logistiques entre la plateforme et les expéditeurs.',
      accessibility: {
        ariaLabel: 'Liste des synchronisations logistiques',
        breadcrumbLabel: 'Fil d’Ariane des synchronisations',
      },
      breadcrumb: [
        {
          text: 'Synchronisation',
          to: { name: 'synchronization-list' },
          ariaLabel: 'Accueil synchronisation',
        },
        {
          text: 'Liste des synchronisations',
          active: true,
          ariaLabel: 'Liste des synchronisations',
        },
      ],
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/synchronization/references',
    name: 'sync-reference-correction',
    props: true,
    component: () => import('@/views/synchronization/ReferenceCorrection.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Correction références',
      pageDesc: 'Modifier les références externes des colis déjà synchronisés.',
      accessibility: {
        ariaLabel: 'Correction des références de synchronisation',
        breadcrumbLabel: 'Fil d’Ariane correction références',
      },
      breadcrumb: [
        {
          text: 'Correction références',
          to: { name: 'sync-reference-correction' },
          ariaLabel: 'Accueil correction références',
        },
        {
          text: 'Modification',
          active: true,
          ariaLabel: 'Modification des références externes',
        },
      ],
      roles: ['admin', 'superadmin', 'admin_developer'],
    },
  },
]
